<template>
    <modal dialog="modal-lg" class="dark-top" :header="showModalTitle" :customClass="'heightAuto'" :footer="showFooter">

        <div slot="title" v-if="showModalTitle">
            <h2>{{modalTitle}}</h2>
        </div>

        <div slot="body">
            <div :is="getModalComponent"></div>
        </div>

        <div v-if="modalFooterType == 'cancelSave'" slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="clickFooterCancel" >Cancel</button>
            <button type="button" class="btn ok wider" @click="clickFooterSave" :disabled="isSaving" >Save</button>
        </div>

    </modal>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Modal from './Modal'

export default {
    data: function () {
        return {
            isSaving: false,
        }
    },
    computed:{
        ...mapGetters([
            'getModalComponent'
        ]),
        showModalTitle: function () {
            return this.getModalComponent.data && this.getModalComponent.data().modalTitle? true : false
        },
        modalTitle: function () {
            return this.getModalComponent.data && this.getModalComponent.data().modalTitle? this.getModalComponent.data().modalTitle : null
        },
        modalFooterType: function () {
            return this.getModalComponent.data && this.getModalComponent.data().modalFooterType? this.getModalComponent.data().modalFooterType : null
        },
        showFooter: function () {
            return this.modalFooterType != null
        }
    },
    methods:{
        ...mapActions([
            'closeModal'
        ]),
        clickFooterCancel: function () {
            if(this.getModalComponent.methods && this.getModalComponent.methods.modalCancel){
                this.getModalComponent.methods.modalCancel()
            }
            this.closeModal()
        },
        clickFooterSave: function () {
            this.isSaving = true;
            
            if(this.getModalComponent.methods && this.getModalComponent.methods.modalSave){
                this.getModalComponent.methods.modalSave()
            }

            this.isSaving = false;
        },
    },
    components:{
        Modal
    }
}
</script>



// WEBPACK FOOTER //
// ComponentModal.vue?b650f6e4